import { config } from "@shared/config";

const emailRegex = /^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/;

const isValidLinkOrEmail = (input: string): boolean => {
  const regex =
    /^(https?:\/\/([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?|[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,})$/i;
  return regex.test(input);
};

// Тип объекта, у которого может быть url
export type UrlData = {
  url?: string | null;
  [key: string]: unknown;
};

export const normalizeUrl = <T extends UrlData>(data: T): T => {
  if (!data.url) {
    return data;
  }

  if (isValidLinkOrEmail(data.url)) {
    if (emailRegex.test(data.url)) {
      return {
        ...data,
        url: `mailto:${data.url}`,
      };
    }
    return data;
  }

  return {
    ...data,
    url: `${config.api.strapiMediaUrl}${data.url}`,
  };
};

// утилита для проверки "объектности"
const isObject = (val: unknown): val is Record<string, unknown> =>
  typeof val === "object" && val !== null && !Array.isArray(val);

export const rebuildUrl = (obj: unknown): unknown => {
  if (isObject(obj)) {
    const n: Record<string, unknown> = {};

    Object.keys(obj).forEach((k) => {
      n[k] = rebuildUrl(obj[k]);
    });

    if ("url" in obj) {
      return normalizeUrl(obj as UrlData);
    }

    return n;
  }

  if (Array.isArray(obj)) {
    return obj.map((i) => rebuildUrl(i));
  }

  return obj;
};
